export default __webpack_public_path__ + "static/paywallTeaserIllustration-85c614b0ebf03547f3c5c5913667f80c.svg";